import { render, staticRenderFns } from "./GetResult.vue?vue&type=template&id=30583d20&scoped=true"
import script from "./GetResult.vue?vue&type=script&lang=js"
export * from "./GetResult.vue?vue&type=script&lang=js"
import style0 from "./GetResult.vue?vue&type=style&index=0&id=30583d20&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30583d20",
  null
  
)

export default component.exports